angular.module("ainapp")
    .controller("pendingSalesDashController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
                function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Pending Sales Dashboard";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {

                $scope.VoucherArray = [];

                $scope.CompanyProfile = {};
                MainService.GetCompanyProfile().then(function (response) {
                    $scope.CompanyProfile = response.data;

                    MainService.SalesEnquiryInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Sales Enquiry",
                            Order: 1,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.SalesEnquiry != "" & $scope.CompanyProfile.SalesEnquiry != null) {
                            temp.VoucherName = $scope.CompanyProfile.SalesEnquiry;
                        }

                        $scope.VoucherArray.push(temp);

                    })


                    MainService.SalesEnquiry2InPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Sales Enquiry 2",
                            Order: 2,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.SalesEnquiry2 != "" & $scope.CompanyProfile.SalesEnquiry2 != null) {
                            temp.VoucherName = $scope.CompanyProfile.SalesEnquiry2;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.SalesEnquiry3InPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Sales Enquiry 3",
                            Order: 3,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.SalesEnquiry3 != "" & $scope.CompanyProfile.SalesEnquiry3 != null) {
                            temp.VoucherName = $scope.CompanyProfile.SalesEnquiry3;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.SalesEnquiry4InPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Sales Enquiry 4",
                            Order: 4,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.SalesEnquiry4 != "" & $scope.CompanyProfile.SalesEnquiry4 != null) {
                            temp.VoucherName = $scope.CompanyProfile.SalesEnquiry4;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.SalesQuotationInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Sales Quotation",
                            Order: 5,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.SalesQuotation != "" & $scope.CompanyProfile.SalesQuotation != null) {
                            temp.VoucherName = $scope.CompanyProfile.SalesQuotation;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.SalesQuotation2InPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Sales Quotation 2",
                            Order: 6,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.SalesQuotation2 != "" & $scope.CompanyProfile.SalesQuotation2 != null) {
                            temp.VoucherName = $scope.CompanyProfile.SalesQuotation2;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.SalesQuotation3InPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Sales Quotation 3",
                            Order: 7,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.SalesQuotation3 != "" & $scope.CompanyProfile.SalesQuotation3 != null) {
                            temp.VoucherName = $scope.CompanyProfile.SalesQuotation3;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.SalesQuotation4InPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Sales Quotation 4",
                            Order: 8,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.SalesQuotation4 != "" & $scope.CompanyProfile.SalesQuotation4 != null) {
                            temp.VoucherName = $scope.CompanyProfile.SalesQuotation4;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.SalesOrderInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Sales Order",
                            Order: 9,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.SalesOrder != "" & $scope.CompanyProfile.SalesOrder != null) {
                            temp.VoucherName = $scope.CompanyProfile.SalesOrder;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.SalesOrder2InPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Sales Order 2",
                            Order: 10,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.SalesOrder2 != "" & $scope.CompanyProfile.SalesOrder2 != null) {
                            temp.VoucherName = $scope.CompanyProfile.SalesOrder2;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.SalesOrder3InPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Sales Order 3",
                            Order: 11,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.SalesOrder3 != "" & $scope.CompanyProfile.SalesOrder3 != null) {
                            temp.VoucherName = $scope.CompanyProfile.SalesOrder3;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.SalesOrder4InPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Sales Order 4",
                            Order: 12,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.SalesOrder4 != "" & $scope.CompanyProfile.SalesOrder4 != null) {
                            temp.VoucherName = $scope.CompanyProfile.SalesOrder4;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.DeliveryNoteInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Delivery Note",
                            Order: 13,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.DeliveryNote != "" & $scope.CompanyProfile.DeliveryNote != null) {
                            temp.VoucherName = $scope.CompanyProfile.DeliveryNote;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.DeliveryNote2InPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Delivery Note 2",
                            Order: 14,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.DeliveryNote2 != "" & $scope.CompanyProfile.DeliveryNote2 != null) {
                            temp.VoucherName = $scope.CompanyProfile.DeliveryNote2;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.DeliveryNote3InPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Delivery Note 3",
                            Order: 15,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.DeliveryNote3 != "" & $scope.CompanyProfile.DeliveryNote3 != null) {
                            temp.VoucherName = $scope.CompanyProfile.DeliveryNote3;
                        }

                        $scope.VoucherArray.push(temp);

                    })

                    MainService.DeliveryNote4InPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Delivery Note 4",
                            Order: 16,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.DeliveryNote4 != "" & $scope.CompanyProfile.DeliveryNote4 != null) {
                            temp.VoucherName = $scope.CompanyProfile.DeliveryNote4;
                        }


                        $scope.VoucherArray.push(temp);

                    })

                    MainService.PackingListInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Packing List",
                            Order: 17,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.PackingList != "" & $scope.CompanyProfile.PackingList != null) {
                            temp.VoucherName = $scope.CompanyProfile.PackingList;
                        }


                        $scope.VoucherArray.push(temp);

                    })

                    MainService.SalesInvoiceInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Sales Invoice",
                            Order: 18,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.SalesInvoice != "" & $scope.CompanyProfile.SalesInvoice != null) {
                            temp.VoucherName = $scope.CompanyProfile.SalesInvoice;
                        }


                        $scope.VoucherArray.push(temp);

                    })

                    MainService.SalesInvoice2InPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Sales Invoice 2",
                            Order: 19,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.SalesInvoice2 != "" & $scope.CompanyProfile.SalesInvoice2 != null) {
                            temp.VoucherName = $scope.CompanyProfile.SalesInvoice2;
                        }


                        $scope.VoucherArray.push(temp);

                    })

                    MainService.SalesInvoice3InPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Sales Invoice 3",
                            Order: 20,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.SalesInvoice3 != "" & $scope.CompanyProfile.SalesInvoice3 != null) {
                            temp.VoucherName = $scope.CompanyProfile.SalesInvoice3;
                        }


                        $scope.VoucherArray.push(temp);

                    })

                    MainService.SalesInvoice4InPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Sales Invoice 4",
                            Order: 21,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.SalesInvoice4 != "" & $scope.CompanyProfile.SalesInvoice4 != null) {
                            temp.VoucherName = $scope.CompanyProfile.SalesInvoice4;
                        }


                        $scope.VoucherArray.push(temp);

                    })


                    MainService.DirSalesInvoiceInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Direct Sales Invoice",
                            Order: 22,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.DirSalesInvoice != "" & $scope.CompanyProfile.DirSalesInvoice != null) {
                            temp.VoucherName = $scope.CompanyProfile.DirSalesInvoice;
                        }


                        $scope.VoucherArray.push(temp);

                    })

                    MainService.ExpSalesInvoiceInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Export Sales Invoice",
                            Order: 23,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.ExpSalesInvoice != "" & $scope.CompanyProfile.ExpSalesInvoice != null) {
                            temp.VoucherName = $scope.CompanyProfile.ExpSalesInvoice;
                        }


                        $scope.VoucherArray.push(temp);

                    })

                    MainService.IndSalesInvoiceInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Individual Sales Invoice",
                            Order: 24,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.IndSalesInvoice != "" & $scope.CompanyProfile.IndSalesInvoice != null) {
                            temp.VoucherName = $scope.CompanyProfile.IndSalesInvoice;
                        }


                        $scope.VoucherArray.push(temp);

                    })

                    MainService.ProSalesInvoiceInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Proforma Invoice",
                            Order: 25,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.ProformaInvoice != "" & $scope.CompanyProfile.ProformaInvoice != null) {
                            temp.VoucherName = $scope.CompanyProfile.ProformaInvoice;
                        }


                        $scope.VoucherArray.push(temp);

                    })

                    MainService.SalesReturnInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Sales Return",
                            Order: 26,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.SalesReturn != "" & $scope.CompanyProfile.SalesReturn != null) {
                            temp.VoucherName = $scope.CompanyProfile.SalesReturn;
                        }


                        $scope.VoucherArray.push(temp);

                    })

                    MainService.CreditNoteSRInPendingDash().then(function (response2) {
                        var temp = {
                            VoucherName: "Credit Note SR",
                            Order: 27,
                            Vouchers: response2.data,
                            Count: response2.data.length
                        }

                        if ($scope.CompanyProfile.CreditNoteSR != "" & $scope.CompanyProfile.CreditNoteSR != null) {
                            temp.VoucherName = $scope.CompanyProfile.CreditNoteSR;
                        }


                        $scope.VoucherArray.push(temp);

                    })



                })





            }
            $scope.Init();

                        }])
